import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { trpc } from '@/lib/trpc/trpc';
import { useToast } from '@/hooks/use-toast';
import { buttonVariants } from '@/components/ui/button';

interface DeleteCalendarBookingProps {
  id: string;
  show: boolean;
  setShow: (open: boolean) => void;
  parentSetShow?: (open: boolean) => void;
}

export default function DeleteCalendarBookingAlert({
  ...props
}: DeleteCalendarBookingProps) {
  const { toast } = useToast();
  const trpcUtils = trpc.useUtils();

  const deleteCalendarBooking = trpc.Booking.DeleteBooking.useMutation({
    onSuccess: () => {
      toast({
        title: 'Booking Deleted',
        description: 'Successfully deleted booking',
      });
      trpcUtils.Booking.invalidate();
      props.setShow(false);
      if (props.parentSetShow) {
        props.parentSetShow(false);
      }
    },
    onError: (error) => {
      toast({
        title: 'Error Deleting Booking',
        description: error.message,
        variant: 'destructive',
      });
      trpcUtils.Booking.invalidate();
      props.setShow(false);
    },
  });

  const confirmHandler = (id: string) => {
    deleteCalendarBooking.mutate({
      bookingId: id,
    });
  };

  return (
    <AlertDialog open={props.show} onOpenChange={props.setShow}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone. Clicking confirm permanently delete
            this booking.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            className={buttonVariants({ variant: 'destructive' })}
            onClick={() => confirmHandler(props.id)}
          >
            Confirm
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
